module.exports = __webpack_public_path__ + "img/task.73a7831d.svg";